<style scoped>
.csu_toast {
  position: fixed;
  width: 100%;
  text-align: center;
  z-index: 9999;
  top: 40%;
  text-align: center;
}

.csu_toast .txt {
  display: inline-block;
  margin: 0 20px;
  min-width: 100px;
  min-height: 20px;
  padding: 10px 20px;

  /*! darkmode: ignore next */
  color: #fff;
  font-size: 16px;
  line-height: 30px;
  border-radius: 8px;

  /*! darkmode: ignore next */
  background-color: #000;

  /*! darkmode: ignore next */
  background-color: rgba(0, 0, 0, 0.8);
}
</style>
<template>
  <div class="csu_toast" v-if="isShow">
    <span class="txt" v-html="msg"></span>
  </div>
</template>
<script>
const toast = {
  msg: '',
  isShow: false,
  showTimeout: 0,
};

export default {
  data() {
    return toast;
  },
  install(Vue) {
    return (Vue.prototype.$toast = function (msg, timeout = 2000) {
      clearTimeout(toast.showTimeout);
      toast.msg = msg;
      toast.isShow = true;
      toast.showTimeout = setTimeout(() => {
        toast.isShow = false;
      }, timeout);
    });
  },
};
</script>
